import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ShoppingCartComponent } from './shopping-cart.component';
// import { TAPShoppingCartComponent } from './shopping-cart.tap.component';
import { SVGModule } from '@ibe.components/common/svg/svg.module';

/* REPLICATED FILES */
import { INDRAShoppingCartComponent } from './shopping-cart.indra.component';
import { PipesModule } from 'src/app/pipes/pipes.module';

@NgModule({
	imports: [ CommonModule, SVGModule, PipesModule ],
	declarations: [ ShoppingCartComponent, INDRAShoppingCartComponent ],
	exports: [ INDRAShoppingCartComponent ]
})
export class ShoppingCartModule {}
